var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{key:_vm.isResourceShow,ref:"cascader",style:(_vm.css),attrs:{"options":_vm.options,"props":_vm.props,"placeholder":_vm.placeholder,"clearable":""},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CategorySelect/index.vue?vue&type=template&id=5c11ffe8&
// module id = null
// module chunks = 